import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { Store } from '@ngxs/store';
// Model
import { IntegrationsUrlParamsModel } from '../../../models/integrations-url-params.model';
import { GenericIntegrationService } from '../../../../service/generic-integration.service';
import { MessageService } from 'primeng/api';
import { OrganizationsService } from '../../../../service/organization.service';

@Component({
	selector: 'cv-invision-ux-static-form',
	templateUrl: './static-form.component.html',
	styleUrls: ['./static-form.component.scss'],
})
export class StaticFormComponent implements OnInit {
	params         = new IntegrationsUrlParamsModel();
	model: any     = null;
	extraData: any = {};
	public data: any;

	public label = 'Default Settings';
	public organizations = [];
	public selectedOrganization = {
		id: '',
		name: ''
	};

	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private route: ActivatedRoute,
		private store: Store,
		public messageService: MessageService,
		private organizationsService: OrganizationsService,
		private service: GenericIntegrationService
	) {}

	ngOnInit(): void {
		this.route.params.pipe(takeUntil(this.atComponentDestroy)).subscribe(params => {
			this.params    = new IntegrationsUrlParamsModel();
			this.model     = null;
			this.extraData = {};
			this.params = Object.assign(this.params, params);

			if ('organizationIntegrationId' in params) {
				this.params.parentIntegrationId = this.params.integrationId;
				this.params.integrationId = params.organizationIntegrationId;
			}

			this.service
				.getData(this.params)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(result => {
					this.data = result;

					// move to a callback section
					this.selectedOrganization = {
						id: this.data.defaultClassOrganizationId,
						name: this.data.defaultClassOrganizationName
					};
				});
		});
	}

	/**
	 * On save grid config.
	 */
	onSave(): void {
		this.service
			.saveData(this.params, this.data)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe({
				next: result => {
					this.messageService.add({ severity: 'success', summary: 'Success', detail: `${this.label} was updated` });
				},
				error: error => {
					console.error(error);
				}
			});
	}

	/**
	 *
	 * @param $event
	 */
	onOrganizationSelect($event: any): void {
		this.data = {
			...this.data,
			...{
				defaultClassOrganizationId: $event.id,
				defaultClassOrganizationName: $event.name
			}
		};
	}

	/**
	 *
	 * @param $event
	 */
	filterOrganizations($event: any): void {
		this.organizationsService
			.getOrganizationsByName($event.query)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				this.organizations = result;
			});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
